module.exports = __webpack_public_path__ + "static/media/ground_water.2b9053d2.svg";